// extracted by mini-css-extract-plugin
export default {"wrapper":"fj+7UX8tl4Gac6nvh45utg==","illustration":"x4Tskx7q3qPjzfU-B1aVwA=="};